"use client";

import {ButtonHTMLAttributes, forwardRef, HTMLAttributes} from 'react';
import AnalyticsEvent from './AnalyticsEvent';
import type {AnalyticsEventName} from '../../context/AnalyticsContext';

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> {
    analyticsEvent?: AnalyticsEventName;
    analyticsProperties?: Record<string, unknown>;
    as?: 'button' | 'div';
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

const Button = forwardRef<HTMLButtonElement | HTMLDivElement, ButtonProps>(function Button(props, ref) {
    const {
        onClick,
        children,
        style,
        className,
        analyticsEvent,
        analyticsProperties,
        as = 'button',
        ...validDomProps
    } = props;

    return (
        <AnalyticsEvent
            ref={ref}
            as={as}
            analyticsEvent={analyticsEvent}
            analyticsProperties={analyticsProperties}
            onClick={onClick}
            style={style}
            className={className}
            {...(validDomProps as HTMLAttributes<HTMLElement>)}
        >
            {children}
        </AnalyticsEvent>
    );
});

export default Button;
